import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../web/components/Button';
import { StarRating } from '../../../../web/components/surveys/StarRating';
import { ISatisfactionSurveyResponse, ISurvey } from '../../../models/Api';
import { useErrorMessagesContext } from '../../ErrorModalProvider/context';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	onRequestSubmit?(response: ISatisfactionSurveyResponse): Promise<any>;
	styles?: StyleDeclarationValue[];
	survey: ISurvey;
}

export const SatisfactionSurvey: React.FC<IProps> = props => {
	const { className, styles = [], survey, onRequestSubmit } = props;
	const ratingStarStyles = React.useRef<StyleDeclarationValue[]>([styleSheet.ratingStar]).current;
	const { pushError } = useErrorMessagesContext();

	const [rating, setRating] = React.useState<number>(0);

	const onSubmitFeedbackClicked = () => {
		if (rating === 0) {
			pushError(['Please provide a rating to continue.']);
			return;
		}
		const response: ISatisfactionSurveyResponse = {
			rating,
		};
		onRequestSubmit?.(response);
	};
	return (
		<div className={`${css(styleSheet.container, ...styles)} satisfaction-survey ${className || ''}`}>
			<div className={css(styleSheet.intro)}>{survey.intro}</div>
			<figure className={css(styleSheet.ratingContainer)}>
				<StarRating
					animateRatingChanges={true}
					fillColor='#F3CE0D'
					onValueChanged={setRating}
					starStyles={ratingStarStyles}
					total={5}
					value={rating}
					showEmoji
				/>
			</figure>
			<Button
				className={css(styleSheet.submitButton)}
				kind='primary'
				label='Submit Star Rating'
				onClick={onSubmitFeedbackClicked}
			/>
		</div>
	);
};
